export default __webpack_public_path__ + "static/media/lds-logo_mk.b4d11bfb4d801105.svg";